module.exports = require("./../../_gen/starling/errors/AbstractMethodError");